"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_redux_1 = require("react-redux");
const useDocumentCache = (slice, ids) => ((0, react_redux_1.useSelector)((state) => (ids.reduce((result, id) => {
    var _a, _b;
    const value = (_b = (_a = state === null || state === void 0 ? void 0 : state.documentCache) === null || _a === void 0 ? void 0 : _a[slice]) === null || _b === void 0 ? void 0 : _b[id];
    return value ? [...result, value] : result;
}, [])), react_redux_1.shallowEqual) || []);
exports.default = useDocumentCache;
